/**
 * Function to be used in Once context to notify segment about
 * a new identification on top of the current analytics context
 *
 * @param {Object} user
 */
export function identifyAnalyticsUser({
  deputyUUID,
  firstname,
  lastname,
  email,
  phone,
}) {
  // Send only the spec Identify traits, not the whole context user.
  // anonymousID: undefined clears the trait the web kiosk (same origin) used
  // to store; analytics-next merges stored traits into every identify.
  const { installationUserID, role } =
    window.__APP__.analyticsContext.user ?? {};
  window.analytics.identify(deputyUUID, {
    deputyUUID,
    installationUserID,
    ...(role && { role }),
    firstName: firstname,
    lastName: lastname,
    email,
    phone,
    // Same anchored, case-sensitive match as ContextProvider::isDeputyEmail().
    deputyEmailFlag: /@deputy\.com$/.test(email || ''),
    anonymousID: undefined,
  });
}
